module.exports = __webpack_public_path__ + "media/images/sp/specials/common/store_yokohama_ekimae-30c8fc467a38346806f4ea03343cb38c.jpg";